// extracted by mini-css-extract-plugin
export default {"root":"_2Eln7ufA","left":"_1cHaj4Oc","right":"iHtP0c17","content":"_3_GxMA2J","logoBox":"A9AkyUXS","logoBorder":"LpQ7Lter"};